// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3GyKA","footer":"ModalUpdate_footer__wjZyG"};